export const defaultSessionDomainState = {
    languageTag: undefined
};
//# sourceMappingURL=state.js.map